import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete } from '../../../../common'

export const FormCashier = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { fetchSpecificCashier, fetchCategories } = FetchData
    const { loadingFetchSpecificCashier } = fetchSpecificCashier
    const { dataCategories, loadingFetchAllCategories } = fetchCategories

    const { onSubmitForm, handleClickHideForm } = Actions
    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idcaja > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificCashier && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="idcategoria">* Categoría</label>
                                    {(loadingFetchAllCategories)&&(<LinearLoading/>)}
                                    <CustomAutocomplete 
                                        customId="idcategoria"
                                        customName="idcategoria"
                                        customValue={formState.idcategoria}
                                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcategoria', value: value.value }})}
                                        customPlaceholder='Selecciona una opcion'
                                        customOptions={
                                            dataCategories.map(({ idcategoria, nombre }) => ({
                                                value: idcategoria,
                                                name: nombre
                                            }))
                                        }
                                        customDisableClearable={true}
                                        customDisabled={false}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="descripcion_corta">* Descripción Corta</label>
                                    <TextField
                                        id="descripcion_corta"
                                        name="descripcion_corta"
                                        value={formState.descripcion_corta}
                                        onChange={onInputChange}
                                        size='small'
                                        type="text"
                                        variant="outlined"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="currency_type">* Tipo</label>
                                    <TextField
                                        id="currency_type"
                                        name="currency_type"
                                        value={formState.currency_type}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant="outlined"
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: false
                                        }}
                                    >
                                        <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                        <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="retirable">* Retirable</label>
                                    <TextField
                                        id="retirable"
                                        name="retirable"
                                        value={formState.retirable}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        variant="outlined"
                                        hiddenLabel
                                        InputProps={{ 
                                            readOnly: false
                                        }}
                                    >
                                        <MenuItem value='SI'>SI</MenuItem>
                                        <MenuItem value='NO'>NO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <label htmlFor="descripcion_larga">* Descripción Larga</label>
                                <FormControl fullWidth>
                                    <TextField
                                        id="descripcion_larga"
                                        name="descripcion_larga"
                                        value={formState.descripcion_larga}
                                        onChange={onInputChange}
                                        size='small'
                                        multiline
                                        rows={3}
                                        type="text"
                                        variant="outlined"
                                        InputProps={{ readOnly: false }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
